import { SELECT_ROOM } from '../actionTypes'

export const selectRoom = (payload: object) => ({ type: SELECT_ROOM, payload })
